"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GlobalEvent = void 0;
const vue_1 = require("vue");
exports.GlobalEvent = vue_1.default.component('global-event', {
    props: {
        globalEvent: {
            type: Object,
        },
        type: {
            type: String,
        },
    },
    methods: {
        partyNameClass: function (partyName) {
            if (partyName === undefined) {
                return '';
            }
            return 'event-party--' + partyName.toLowerCase().split(' ').join('_');
        },
        getClass: function () {
            const common = 'global-event';
            switch (this.type) {
                case 'coming':
                    return common + ' global-event--coming';
                case 'current':
                    return common + ' global-event--current';
                default:
                    return common;
            }
        },
    },
    template: `
    <div :class="getClass()">
      <div class="event-party event-party--top" :class="partyNameClass(globalEvent.revealed)" v-i18n>{{ globalEvent.revealed }}</div>
      <div class="event-party event-party--bottom" :class="partyNameClass(globalEvent.current)" v-i18n>{{ globalEvent.current }}</div>
      <div class="event-content"><div class="event-text" v-i18n>{{ globalEvent.description }}</div></div>
    </div>
    `,
});
//# sourceMappingURL=GlobalEvent.js.map